module.exports = __webpack_public_path__ + "img/adam.96681471.jpg";